/** Symbol.observable or a string "@@observable". Used for interop */
export var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map